import { render, staticRenderFns } from "./CategoriaForm.vue?vue&type=template&id=567d67a6"
import script from "./CategoriaForm.vue?vue&type=script&lang=js"
export * from "./CategoriaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports